import React, { useEffect, useState } from 'react'
import 'react-html5-camera-photo/build/css/index.css';
import BottomMenu from "../layout/bottomMenu";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import NotFoundData from "../../Images/no-data-found.webp";
import ReactPaginate from 'react-paginate';

const JourneyTravelled = ({
    match,
    history,
    getJourneyTravelled,
    journeyTravelled,
    getJourneyTravelledByFilter,
    filter
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [filterView, setfilterView] = useState([{}]);
    const [filterInputList, setFilterInputList] = useState([{assigned_to:'', from_date:'', to_date:''}]);
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false);
    const [pageNo, setPage] = useState(1);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getJourneyTravelled(pageNo, localStorage.getItem("module_type"))
            await getJourneyTravelledByFilter()
            setIsLoading(false)
        })()
    }, [])

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected + 1)
        await getJourneyTravelled(pageNo, localStorage.getItem("module_type"),filterInputList[0].assigned_to, filterInputList[0].from_date, filterInputList[0].to_date)
        setIsLoading(false)
    };

    const handleFilter = async (key, value, stringValue = '') => {
        const list = [...filterInputList]
        const view = [...filterView]
        console.log(filterInputList)
        list[0][key] = value
        view[0][key] = value
        if (stringValue !== '') {
            view[0][key] = stringValue
            setfilterView(view)
        } else {
            setfilterView(view)
        }
        setFilterInputList(list)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await getJourneyTravelled(pageNo, localStorage.getItem("module_type"),filterInputList[0].assigned_to, filterInputList[0].from_date, filterInputList[0].to_date)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterView[0][key]
            delete filterInputList[0][key]
            setfilterView(filterView)
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await getJourneyTravelled(pageNo, localStorage.getItem("module_type"),filterInputList[0].assigned_to, filterInputList[0].from_date, filterInputList[0].to_date)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setfilterView([{}])
                setFilterInputList([{}])
                setIsLoading(true)
                await getJourneyTravelled(pageNo, localStorage.getItem("module_type"))
                setIsLoading(false)
                setIsRemoveFilter(false)
            }

        })()
    }, [isFilterRemove])

    return (
        <>
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css"
                    integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz"
                    crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"></link>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Journey Travelled'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row b-13">
                                    {/*<div className="form-check form-switch global-search">*/}
                                    {/*    <input type="checkbox" id="switch" onChange={(e) => setIsGlobalSearch(e.target.checked)}/>*/}
                                    {/*    <label className="radio-btn" for="switch">Global Search</label>*/}
                                    {/*    <span className="serach-title">Search account globally..</span>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-5">
                                    <div className="row col-md-12">
                                        <div className="col-md-12 cs-pos">
                                            <button onClick={() => setOpen(!open)}
                                                className="btn btn-sm btn-primary mr-1 mt-1 btn-filter btn-filter-2"
                                                type="button"><i
                                                    className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {filterView[0] !== undefined && Object.keys(filterView[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        {console.log(filterView[0])}
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterView[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                                <span className="fd-1">
                                                                    <span style={{ textTransform: "capitalize" }}>
                                                                        {val.replaceAll("_", " ")}
                                                                    </span>
                                                                    {" - " + filterView[0][val]}
                                                                    <i className="bi bi-x-circle" onClick={(e) => {
                                                                        handleRemoveFilter(val)
                                                                    }}></i>
                                                                </span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* Filter View End*/}
                                <div className="row">
                                    {/*CARD START*/}
                                    {journeyTravelled && journeyTravelled?.data?.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                            data-color=""
                                                            data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    <div className="row list-view">
                                                                        {val["travel_date"] !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Travel Date
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{val["travel_date"]}</div>
                                                                            </div>
                                                                        }
                                                                        {val["tolls"] !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fab fa-accusoft"></i>&nbsp;&nbsp;No. of Tolls
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{val["count"]}</div>
                                                                            </div>
                                                                        }
                                                                        {val["total_distance"] !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-map"></i>&nbsp;&nbsp;Total Distance
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{parseInt(val["d1"])+parseInt(val["d2"])+parseFloat(val["d3"])}</div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {journeyTravelled && journeyTravelled?.data !== undefined && journeyTravelled?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(journeyTravelled?.total / journeyTravelled?.per_page)}
                                                forcePage={journeyTravelled?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }

                                    {journeyTravelled && journeyTravelled?.data?.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" />
                                            <div className="text-center" style={{ "width": "100%" }}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    filterContent={filter}
                    handleFilter={handleFilter}
                    handleSubmitFilter={handleSubmitFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
        </>
    )
}

export default JourneyTravelled